import { jsPDF } from "jspdf";
import { drawLetterHead, drawFooter, inWords, longDate } from "@/components/hr/JoiningLetter";
import { monthLabel } from "@/lib/payslip";

const rs = (n) => `Rs. ${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const buildIncrementPdf = async (I) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const c = I.company || {};
  const co = c.name || "the Company";
  const X = 20, W = 170;
  let y;
  const para = (t, gap = 4) => {
    doc.setFont("helvetica", "normal"); doc.setFontSize(10);
    const lines = doc.splitTextToSize(t, W);
    doc.text(lines, X, y); y += lines.length * 5 + gap;
  };
  await drawLetterHead(doc, c);
  y = 50;
  doc.setFont("helvetica", "bold"); doc.setFontSize(15);
  doc.text("SALARY INCREMENT LETTER", 105, y, { align: "center" }); y += 12;
  para(`Date: ${longDate(I.created_at)}`, 2);
  para(`Letter No.: ${I.letter_no}`, 6);
  para("To,", 2);
  para(`Mr./Ms. ${I.employee_name}`, 2);
  if (I.employee_code) para(`Employee ID: ${I.employee_code}`, 2);
  if (I.designation) para(`Designation: ${I.designation}`, 2);
  y += 4;
  doc.setFont("helvetica", "bold"); doc.setFontSize(11.5); doc.text("Subject: Salary Increment", X, y); y += 8;
  para(`Dear Mr./Ms. ${I.employee_name},`);
  para(`We are pleased to inform you that, in recognition of your performance and contribution to ${co}, your salary has been revised with effect from ${monthLabel(I.effective_month)}.`);

  const ctc = Math.round(I.new_salary * 12);
  const rows = [
    ["Employee Name:", I.employee_name], ["Employee ID:", I.employee_code], ["Designation:", I.designation],
    ["Department:", I.department], ["Previous Monthly Salary:", rs(I.old_salary)],
    ["Increment:", `${rs(I.increment_amount)} (${I.percent}%)`], ["Revised Monthly Salary:", rs(I.new_salary)],
    ["Revised Annual CTC:", `Rs. ${ctc.toLocaleString("en-IN")}`], ["Effective From:", monthLabel(I.effective_month)],
  ].filter(([, v]) => v);
  y += 2;
  doc.setDrawColor(210); doc.setLineWidth(0.2);
  rows.forEach(([k, v]) => {
    doc.rect(X, y, 70, 9); doc.rect(X + 70, y, W - 70, 9);
    doc.setFont("helvetica", "bold"); doc.setFontSize(9.5); doc.text(k, X + 3, y + 6);
    doc.setFont("helvetica", "normal"); doc.text(String(v), X + 73, y + 6);
    y += 9;
  });
  y += 7;
  para(`Your revised Annual Cost to Company (CTC) shall be Rs. ${ctc.toLocaleString("en-IN")} (Rupees ${inWords(ctc)} Only) per annum, subject to applicable taxes and statutory deductions.`);
  if (I.reason) para(`Remarks: ${I.reason}`);
  para("All other terms and conditions of your employment remain unchanged.");
  para("We appreciate your efforts and look forward to your continued contribution to the growth of the Company.", 10);
  doc.setFont("helvetica", "bold"); doc.setFontSize(10);
  doc.text(`For ${c.name || ""}`, X, y); y += 18;
  doc.text("Authorized Signatory", X, y);
  drawFooter(doc, c);
  return doc;
};

export const incrementFileName = (I) => `Increment_Letter_${I.employee_name.replace(/\W+/g, "_")}_${I.letter_no.replace(/\//g, "-")}.pdf`;
